import { render } from "./AssistantMessage.vue?vue&type=template&id=374d9748&scoped=true"
import script from "./AssistantMessage.vue?vue&type=script&lang=js"
export * from "./AssistantMessage.vue?vue&type=script&lang=js"

import "./AssistantMessage.vue?vue&type=style&index=0&id=374d9748&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374d9748"]])

export default __exports__